import Signatures from './signatures';

export default {
  Signatures,
};
